var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row body-main-row"
  }, [_c('div', {
    staticClass: "member_dashboard member-body-content-wrap"
  }, [_c('div', {
    staticClass: "claim-wrap"
  }, [_c('div', {
    staticClass: "claim-contents"
  }, [_c('div', {
    staticClass: "claim-title"
  }, [_c('h1', [_vm._v("Claim Listing - " + _vm._s(_vm.user.name))]), _c('div', [_c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.downloadFileModal",
      modifiers: {
        "downloadFileModal": true
      }
    }],
    staticClass: "download-file-btn"
  }, [_c('i', {
    staticClass: "fas fa-download"
  }), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("Download the claim")])]), _c('button', {
    staticClass: "upload-file-btn",
    on: {
      "click": _vm.openForm
    }
  }, [_c('i', {
    staticClass: "fas fa-upload"
  }), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("Upload the claim")])])])]), _c('file-download-modal'), _c('div', {
    staticClass: "claim-list-tbl table-responsive"
  }, [_vm.claimList.length < 1 ? _c('p', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v(" No data found ")]) : _c('table', {
    staticClass: "table w-100"
  }, [_vm._m(0), _c('tbody', _vm._l(_vm.claimList, function (claim, index) {
    var _claim$status, _claim$status2;
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "57%"
      }
    }, [_vm._v(_vm._s(claim.plan_name))]), _c('td', {
      class: claim === null || claim === void 0 ? void 0 : (_claim$status = claim.status) === null || _claim$status === void 0 ? void 0 : _claim$status.toLowerCase()
    }, [_vm._v(" " + _vm._s(claim === null || claim === void 0 ? void 0 : (_claim$status2 = claim.status) === null || _claim$status2 === void 0 ? void 0 : _claim$status2.toUpperCase()) + " ")]), _c('td', [_c('strong', [_vm._v("Added: ")]), _vm._v(" " + _vm._s(_vm.formatDate(claim.created_at))), _c('br'), claim.submitted_at ? _c('span', [_c('strong', [_vm._v("Submitted: ")]), _vm._v(" " + _vm._s(_vm.formatDate(claim.submitted_at)))]) : _vm._e()]), _c('td', {
      staticClass: "text-center"
    }, [_c('b-badge', {
      style: {
        backgroundColor: _vm.statusClass(claim === null || claim === void 0 ? void 0 : claim.email_delivery_status)
      },
      attrs: {
        "pill": ""
      }
    }, [_vm._v(" " + _vm._s((claim === null || claim === void 0 ? void 0 : claim.email_delivery_status) || 'Not Available') + " ")])], 1), _c('td', {
      staticClass: "d-flex align-items-center"
    }, [_c('div', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "mr-3 action-bg",
      attrs: {
        "title": claim.status.toLowerCase() === 'submitted' ? 'View File' : 'Edit/View File'
      },
      on: {
        "click": function click($event) {
          return _vm.viewFile(claim);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-eye"
    })]), claim.status.toLowerCase() === 'pending' ? _c('div', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "action-bg submit-file",
      attrs: {
        "title": "Submit file"
      },
      on: {
        "click": function click($event) {
          return _vm.openSubmitModal(claim);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/file-circle.svg"),
        "alt": "submit"
      }
    })]) : _vm._e()])]);
  }), 0)]), _vm.selectedFiles ? _c('file-submit-modal', {
    attrs: {
      "files": _vm.selectedFiles,
      "claimData": _vm.claimData
    },
    on: {
      "close": function close($event) {
        _vm.selectedFiles = null;
      }
    }
  }) : _vm._e(), _c('file-upload-modal', {
    attrs: {
      "isEdit": _vm.isEdit,
      "row": _vm.selectedClaim
    },
    on: {
      "close": function close($event) {
        _vm.selectedClaim = null;
      },
      "update-isEdit": function updateIsEdit($event) {
        _vm.isEdit = $event;
      }
    }
  })], 1)], 1)])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("Plan")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Date")]), _c('th', [_vm._v("Email Status")]), _c('th', [_vm._v("Action")])])]);
}]

export { render, staticRenderFns }